<div class="my-bids-page-wrapper" [class.mobile]="topService.isMobile">
  <div class="my-bids-navigation-wrapper" *ngIf="!topService.isMobile">
    <app-my-bids-left-nav></app-my-bids-left-nav>
  </div>
  <div class="my-bids-content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
